import TicketSales from './TicketSales';
import './TicketSales.scss';

export default TicketSales;
